import React from 'react'
import Layout from '../../Layout'
import EditProductBaseSupplierContainer from '../../../../Components/ProductRegisterPart/EditProductBaseSupplierContainer/EditProductBaseSupplierContainer'

const EditProductBaseSupplier = () => {
  return (
    <Layout>
        <EditProductBaseSupplierContainer/>
    </Layout>
  )
}

export default EditProductBaseSupplier